import React from "react";
import useAppStore from "src/stores/appStore";
import { selectedAssistantSelector, systemModeSelector } from "src/stores/selectors/appSelectors";
import { ASSISTANT_CHANNELS, ASSISTANT_ENVIRONMENT, TOOLTIP_DELAY, BUILD_STATUSES } from "@consts";
import { List, ListItem, ListItemButton, ListItemText, Popover, styled } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import { SHARE_PREVIEW_TOOLTIP_TITLE } from "@phrasing";
import { SYSTEM_MODES } from "src/stores/slices/createAppSlice";
import { previewLiveBuildResponseSelector } from "src/stores/selectors/previewSelectors";

const PreviewDropdown = ({ align = "left", anchorEl, setAnchorEl, setPhoneDialogOpen, setIsSharePreviewDialogOpen, handleOpenWidget }) => {
  const systemMode = useAppStore(systemModeSelector);
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const previewBuildResponse = useAppStore(previewLiveBuildResponseSelector);
  const isPhone = selectedAssistant?.channel === ASSISTANT_CHANNELS.PHONE;
  const isShareable = selectedAssistant?.environment === ASSISTANT_ENVIRONMENT.PRODUCTION || systemMode === SYSTEM_MODES.EDIT || previewBuildResponse?.status === BUILD_STATUSES.LIVE;

  const handlePreviewClick = () => {
    setAnchorEl(null);

    if (isPhone) setPhoneDialogOpen(true);
    else handleOpenWidget();
  };

  const handleSharePreviewClick = () => {
    setAnchorEl(null);
    setIsSharePreviewDialogOpen(true);
  };

  return (<>
    <Popover
      open={!!anchorEl}
      sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
      anchorEl={anchorEl}
      placement="bottom-end"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: align
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: align
      }}
      PaperProps={{
        sx: {
          marginTop: "8px"
        }
      }}
      onClose={() => setAnchorEl(null)}>
      <StyledList>
        <StyledListItem>
          <StyledListItemButton onClick={handlePreviewClick}>
            Test your AI Agent
          </StyledListItemButton>
        </StyledListItem>
        <StyledListItem>
          <Tooltip title={isShareable ? "" : SHARE_PREVIEW_TOOLTIP_TITLE} placement="bottom" tooltipStyle={{ maxWidth: "150px" }} enterDelay={TOOLTIP_DELAY.LONG} enterNextDelay={TOOLTIP_DELAY.LONG}>
            <StyledListItemButton data-testid="share-preview-button" disabled={!isShareable} onClick={handleSharePreviewClick}>
              Share your AI Agent
            </StyledListItemButton>
          </Tooltip>
        </StyledListItem>
        <StyledListItem>
          <StyledListItemText
            primary="Preview conversations are marked as tests, without affecting live data."
            primaryTypographyProps={{ fontSize: "11px", lineHeight: "15px" }} />
        </StyledListItem>
      </StyledList>
    </Popover>
  </>);
};

const StyledList = styled(List)({
  width: "220px",
  padding: "8px",
  borderRadius: "8px",
  backgroundColor: "white"
});

const StyledListItem = styled(ListItem)({
  padding: "0px",
  "&:nth-of-type(2)": {
    marginBottom: "4px"
  },
  "& > div": {
    flex: 1
  }
});

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: "8px 10px",
  color: theme.palette.text[800],
  borderRadius: "8px",
  fontSize: "14px"
}));

const StyledListItemText = styled(ListItemText)({
  position: "relative",
  padding: "12px 8px 0",
  color: "#2D2C44B2",
  "&::before": {
    content: "''",
    position: "absolute",
    left: "-8px",
    right: "-8px",
    top: "0px",
    height: "1px",
    width: "calc(100% + 16px)",
    backgroundColor: "#2D2C441F"
  }
});

export default PreviewDropdown;
